import React from 'react';
import '../Pages.css';
import '../Pips/Pips.css';

// The one pagination bar used on every list page:
//   "1–10 of 42 records"            Per page [10]   ← Prev  Page 1 of 5  Next →
// Pages keep their own currentPage / itemsPerPage state and slice their list.
export default function Pagination({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  itemLabel = 'record',
  perPageOptions = [5, 10, 25, 50]
}) {
  const totalPages = Math.max(1, Math.ceil((totalItems || 0) / itemsPerPage));
  const page = Math.min(Math.max(1, currentPage), totalPages);
  const start = totalItems ? (page - 1) * itemsPerPage + 1 : 0;
  const end = Math.min(page * itemsPerPage, totalItems || 0);
  const options = perPageOptions.includes(itemsPerPage)
    ? perPageOptions
    : [...perPageOptions, itemsPerPage].sort((a, b) => a - b);

  return (
    <div className="pagination-controls">
      <div className="pagination-left">
        <span className="pagination-info">
          {start}–{end} of {totalItems || 0} {itemLabel}{totalItems === 1 ? '' : 's'}
        </span>
      </div>
      <div className="pagination-right">
        {onItemsPerPageChange && (
          <div className="pagination-per-page">
            <span>Per page:</span>
            <select value={itemsPerPage} onChange={(e) => onItemsPerPageChange(Number(e.target.value))}>
              {options.map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
        )}
        <div className="pagination pagination-pages">
          <button type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>← Prev</button>
          <span className="pagination-info">Page {page} of {totalPages}</span>
          <button type="button" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>Next →</button>
        </div>
      </div>
    </div>
  );
}
